import React, { useEffect } from "react";
import { CircleMarker, GeoJSON, MapContainer, Marker, Popup, TileLayer, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { FRANCE, MAP_PROVIDERS, TYPE_COLOR } from "../../lib/planning";

const color = (p) => (p.a_planifier.length ? TYPE_COLOR[p.a_planifier[0].type] : p.rdvs.length ? "#334155" : "#94A3B8");
const numIcon = (n) => L.divIcon({ className: "", html: `<div style="background:#111827;color:#fff;border:2px solid #fff;border-radius:9999px;width:24px;height:24px;display:flex;align-items:center;justify-content:center;font:600 11px sans-serif;box-shadow:0 1px 4px rgba(0,0,0,.4)">${n}</div>`, iconSize: [24, 24], iconAnchor: [12, 12] });
const depIcon = L.divIcon({ className: "", html: `<div style="background:#2E4734;color:#fff;border:2px solid #fff;border-radius:6px;padding:2px 6px;font:600 10px sans-serif;white-space:nowrap">Départ</div>`, iconAnchor: [24, 10] });

function Fit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length) map.fitBounds(L.latLngBounds(points.map((p) => [p.lat, p.lng])).pad(0.15), { maxZoom: 11 });
  }, [points.length]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export default function PlanningMap({ points, selected, onToggle, route, provider = "osm" }) {
  const tiles = MAP_PROVIDERS[provider] || MAP_PROVIDERS.osm;
  return (
    <MapContainer center={FRANCE.center} zoom={FRANCE.zoom} className="h-full w-full rounded-lg z-0" data-testid="planning-map">
      <TileLayer url={tiles.url} attribution={tiles.attribution} />
      <Fit points={points} />
      {points.map((p) => {
        const sel = selected.includes(p.dossier_id);
        return (
          <CircleMarker key={p.dossier_id} center={[p.lat, p.lng]} radius={sel ? 10 : 7} eventHandlers={{ click: () => onToggle(p.dossier_id) }}
            pathOptions={{ color: sel ? "#111827" : "#fff", weight: sel ? 3 : 1.5, fillColor: color(p), fillOpacity: 0.9 }}>
            <Tooltip direction="top" offset={[0, -6]}><b>{p.label}</b> · {p.ville}<br />{p.a_planifier.map((a) => a.label).join(" · ") || (p.rdvs[0] ? `${p.rdvs[0].type_label} le ${p.rdvs[0].start.slice(0, 10).split("-").reverse().join("/")}` : "")}</Tooltip>
          </CircleMarker>
        );
      })}
      {route?.geometry && <GeoJSON key={JSON.stringify(route.stops.map((s) => s.dossier_id))} data={route.geometry} style={{ color: "#111827", weight: 4, opacity: 0.7 }} />}
      {route?.stops.map((s, i) => <Marker key={s.dossier_id} position={[s.lat, s.lng]} icon={numIcon(i + 1)}><Popup>{i + 1}. {s.label}</Popup></Marker>)}
      {route?.depart && <Marker position={[route.depart.lat, route.depart.lng]} icon={depIcon}><Popup>{route.depart.label}</Popup></Marker>}
    </MapContainer>
  );
}
